import type { ReactNode } from "react";
import { useOffsiteConfig } from "@/engine/app/offsite-context";

export function WaitingScreen({
  label = "Die Präsentation läuft.",
  title,
  zusatz,
}: {
  label?: string;
  /** Überschrift. Ohne Angabe „Bleib dran“ — geduzt, für das Offsite richtig. */
  title?: string;
  /**
   * Zweite Zeile unter dem Label, für harte Zahlen: „3 von 6 Prototypen fertig".
   * Ein Wartebildschirm ohne Fortschritt lässt offen, ob überhaupt etwas
   * passiert oder ob etwas kaputt ist.
   */
  zusatz?: ReactNode;
}) {
  const { formal, ergebnisse } = useOffsiteConfig();
  return (
    <section
      style={{
        padding: "3rem 1rem",
        textAlign: "center",
        display: "grid",
        gap: 18,
        placeItems: "center",
      }}
    >
      <div className="waiting-pulse" aria-hidden="true" />
      <div className="deck-eyebrow">Live</div>
      <h2
        className="deck-title"
        style={{ fontSize: "clamp(1.4rem, 5vw, 2rem)", margin: 0 }}
      >
        {title ?? (formal ? "Einen Moment" : "Bleib dran")}
      </h2>
      <p className="deck-sub" style={{ marginTop: 0 }}>
        {label}
      </p>
      {zusatz && (
        <p className="waiting-zusatz" role="status" data-testid="waiting-zusatz">
          {zusatz}
        </p>
      )}
      {/* Nach dem Offsite steht die Phase wieder auf „waiting" — wer die Seite
          dann aufruft, sucht seinen Prototypen und nicht die nächste Runde. */}
      {ergebnisse && (
        <p style={{ margin: 0 }} data-testid="waiting-ergebnisse">
          <a href={ergebnisse.url}>{ergebnisse.label} →</a>
        </p>
      )}
    </section>
  );
}
